export default "__VITE_ASSET__Ti4CHiMj__"